/**
 * Returns a new object with nested values removed when they match any value included in `valuesToOmit`
 * @param obj The object that needs purified
 * @param valuesToOmit Values to not include in returned object
 * @returns The object with all matching params removed (note: does not preserve Set type(s))
 *
 * ```ts
 * const myObj = { a: 1, b: '', c: 'Hi' }
 * const noEmptyStrings = omitDeep(myObj, [''])
 * console.log(noEmptyStrings)
 * // OUTPUT: { a: 1, c: 'Hi' }
 * ```
 */
export const omitDeep = (obj, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
valuesToOmit) => {
    return JSON.parse(JSON.stringify(obj, (__key, value) => {
        if (value instanceof Set) {
            value = Array.from(value);
        }
        return valuesToOmit.some((omitValue) => omitValue === value) ? undefined : value;
    }));
};
export const omitNullDeep = (obj) => {
    return omitDeep(obj, [null]);
};
export const omitEmptyStringDeep = (obj) => {
    return omitDeep(obj, ['']);
};
export const objHasKeys = (obj) => Object.keys(obj).length > 0;
export const pickKeys = () => (obj, keys) => Object.fromEntries(keys.map((key) => [key, obj[key]]));
export function fromEntries(entries) {
    return Object.fromEntries(entries);
}
export function getAllObjectPaths(obj, currentPath = []) {
    let paths = [];
    for (const key in obj) {
        const newPath = [...currentPath, key];
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            paths = paths.concat(getAllObjectPaths(obj[key], newPath));
        }
        else {
            paths.push(newPath.join('.'));
        }
    }
    return paths;
}
